import React, { useEffect, useState } from "react";
import api from "../lib/api";
import { Trash2, Mail, Phone, MapPin, Clock } from "lucide-react";

const STATUSES = ["new", "contacted", "quoted", "won", "lost"];
const statusColor = {
  new: "text-[#2f9fe6] bg-[#2f9fe6]/15",
  contacted: "text-amber-400 bg-amber-400/15",
  quoted: "text-purple-400 bg-purple-400/15",
  won: "text-emerald-400 bg-emerald-400/15",
  lost: "text-red-400 bg-red-400/15",
};

export default function Leads() {
  const [leads, setLeads] = useState([]);
  const [loading, setLoading] = useState(true);
  const [tab, setTab] = useState("all");

  const load = () => {
    api.get("/admin/leads").then((res) => setLeads(res.data)).finally(() => setLoading(false));
  };
  useEffect(() => {
    load();
  }, []);

  const updateStatus = async (id, status) => {
    await api.patch(`/admin/leads/${id}`, { status });
    setLeads((ls) => ls.map((l) => (l.id === id ? { ...l, status } : l)));
  };
  const remove = async (id) => {
    if (!window.confirm("Delete this lead?")) return;
    await api.delete(`/admin/leads/${id}`);
    setLeads((ls) => ls.filter((l) => l.id !== id));
  };

  const tabs = [
    { key: "all", label: "All", count: leads.length },
    { key: "estimate-form", label: "Estimate", count: leads.filter((l) => l.source === "estimate-form").length },
    { key: "contact-form", label: "Contact", count: leads.filter((l) => l.source === "contact-form").length },
  ];
  const filtered = tab === "all" ? leads : leads.filter((l) => l.source === tab);

  const fmt = (iso) => {
    try { return new Date(iso).toLocaleString(); } catch { return ""; }
  };

  return (
    <div>
      <h1 className="text-white font-display text-4xl font-bold mb-1">Leads <span className="text-[#6b7683] text-2xl">({leads.length})</span></h1>
      <p className="text-[#6b7683] mb-8">Inbound enquiries from the website.</p>

      <div className="flex flex-wrap gap-2 mb-8">
        {tabs.map((t) => (
          <button key={t.key} onClick={() => setTab(t.key)} className={`px-5 py-2.5 rounded-lg text-sm font-semibold border transition-colors ${tab === t.key ? "bg-white/5 border-[#2f9fe6] text-white" : "border-white/10 text-[#9aa4af] hover:text-white"}`}>
            {t.label} ({t.count})
          </button>
        ))}
      </div>

      {loading ? (
        <div className="text-[#6b7683]">Loading...</div>
      ) : filtered.length === 0 ? (
        <div className="text-[#6b7683] bg-[#141a22] rounded-xl p-12 text-center border border-white/5">No leads yet. Submissions from the website forms will appear here.</div>
      ) : (
        <div className="space-y-4">
          {filtered.map((l) => (
            <div key={l.id} className="bg-[#141a22] rounded-xl p-6 border border-white/5">
              <div className="flex flex-col lg:flex-row lg:items-start gap-6">
                <div className="lg:w-1/4">
                  <div className="text-white font-display text-lg font-semibold">{l.name}</div>
                  <span className="inline-block mt-2 px-2.5 py-1 rounded-md bg-white/5 text-[#9aa4af] text-xs uppercase tracking-wide">{(l.source || "").replace("-form", "") || "general"}</span>
                </div>
                <div className="lg:w-1/4 space-y-1.5 text-sm">
                  <a href={`mailto:${l.email}`} className="flex items-center gap-2 text-[#c7ced5] hover:text-[#2f9fe6]"><Mail className="w-4 h-4" /> {l.email}</a>
                  {l.phone && <a href={`tel:${l.phone}`} className="flex items-center gap-2 text-[#c7ced5] hover:text-[#2f9fe6]"><Phone className="w-4 h-4" /> {l.phone}</a>}
                  {l.service && <div className="flex items-center gap-2 text-[#9aa4af]"><MapPin className="w-4 h-4" /> {l.service}</div>}
                </div>
                <div className="flex-1">
                  <p className="text-[#c7ced5] text-sm leading-relaxed">{l.message || "—"}</p>
                  <div className="flex items-center gap-2 mt-3 text-[#5b6672] text-xs"><Clock className="w-3.5 h-3.5" /> {fmt(l.created_at)}</div>
                </div>
                <div className="flex items-center gap-3">
                  <select value={l.status || "new"} onChange={(e) => updateStatus(l.id, e.target.value)} className={`px-3 py-2 rounded-lg text-sm font-medium border border-white/10 outline-none cursor-pointer ${statusColor[l.status] || statusColor.new}`}>
                    {STATUSES.map((s) => (<option key={s} value={s} className="bg-[#141a22] text-white">{s}</option>))}
                  </select>
                  <button onClick={() => remove(l.id)} className="text-[#6b7683] hover:text-red-400 transition-colors"><Trash2 className="w-5 h-5" /></button>
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
